export const routePages = [
    {
        id: 1,
        path: '/',
        cmp: "Inicio",
        initSection: {
            textLight: "Soy ",
            textBold: "Agustín Galluzzo",
            boldDisplayBlock: true,
            background: "url(./assets/images/b&w.jpg)"
        },
        exact: true
    },
    {
        id: 2,
        path: '/trabajos',
        cmp: "Trabajos",
        initSection: false,
        exact: false
    },
    {
        id: 3,
        path: '/sobremi',
        cmp: "SobreMi",
        initSection: {
            textLight: "Soy ",
            textBold: "Agustín Galluzzo",
            boldDisplayBlock: true,
            background: "url(./assets/images/b&w.jpg)",
            subtitle: "Periodista Deportivo"
        },
        exact: false
    },
    {
        id: 4,
        path: '/contacto',
        cmp: "Contacto",
        initSection: false,
        exact: false
    },
    {
        id: 5,
        path: '/',
        cmp: "Error404",
        initSection: false,
        exact: false,
        error404: true
    },
];

export const contactScreen = {
    contactForm: [
        { id: "name", type: "text", value: "", placeholder: "Nombre", change: null, validationRegister: { required: "Debe ingresar un nombre" } },
        {
            id: "email", type: "text", value: "", placeholder: "Email", change: null, validationRegister: {
                required: "Debe ingresar un email",
                pattern: { value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, message: "Dirección de correo inválida" }
            }
        },
        {
            id: "phone", type: "number", value: "", placeholder: "Teléfono", change: null, validationRegister: { required: "Debe ingresar un teléfono" }
        },
        { id: "message", textarea: true, value: "", placeholder: "Mensaje", change: null, cols: "30", rows: "10", validationRegister: { required: "Debe ingresar un mensaje" } }
    ]
}

export const signInScreen = {
    contactForm: [
        {
            id: "email", type: "text", label: "Email", validationRegister: {
                required: "Debe ingresar un email",
                pattern: { value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, message: "Dirección de correo inválida" }
            }
        },
        { id: "password", type: "password", label: "Contraseña", validationRegister: { required: "Debe ingresar una contraseña" } }
    ]
}